import { z } from 'zod';

export const SecurityTestCaseGenerationHarnessSchema = z.enum([
  'CLAUDE_CODE',
  'CODEX',
]);

export const SecurityTestCaseGenerationModelSchema = z.string().trim().min(1);

export const SecurityTestCaseGenerationAttributionSchema = z
  .object({
    harness: SecurityTestCaseGenerationHarnessSchema,
    model: SecurityTestCaseGenerationModelSchema,
  })
  .strict();

export type SecurityTestCaseGenerationAttribution = z.infer<
  typeof SecurityTestCaseGenerationAttributionSchema
>;

const SignalGenerationMetadataSchema = z
  .object({
    generationAttribution:
      SecurityTestCaseGenerationAttributionSchema.optional(),
  })
  .passthrough();

export const parseSecurityTestCaseGenerationAttribution = (
  metadata: unknown,
): SecurityTestCaseGenerationAttribution | undefined => {
  const parsed = SignalGenerationMetadataSchema.safeParse(metadata);

  return parsed.success ? parsed.data.generationAttribution : undefined;
};
